import { Box, Typography } from '@mui/material';
import {
  moonRushInfo,
  rushGrandPrizeProgress,
} from '@/components/features/casino/rush/state';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';
import useTheme from '@/theme/useTheme';
import { styled } from '@mui/material/styles';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: '#0D0D0F',
  },
  [`& .${linearProgressClasses.bar}`]: {
    background: 'linear-gradient(90deg, #5C5C5F 0%, #EEA433 100%)',
    boxShadow: '0px 0px 16px 0px #FCCE49',
  },
}));
export default function GrandPrizeProgress() {
  const progress = useAtomValue(rushGrandPrizeProgress);
  const rushInfo = useAtomValue(moonRushInfo);
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        p: (theme) => theme.spacing(2, 2, 0, 2),
        [theme.breakpoints.down('md')]: {
          p: (theme) => theme.spacing(1, 1, 0, 1),
        },
      }}
    >
      <Typography
        sx={{
          mr: 1,
          fontSize: '16px',
          fontWeight: 500,
        }}
      >
        {t('Points Remaining')}
        {/*({rushInfo?.rushPoint}/*/}
        {/*{rushInfo?.currentGamePoint})*/}
      </Typography>
      <Box
        sx={{
          flex: 1,
          border: '1px solid rgba(255, 255, 255, 0.45)',
          p: 0.2,
          borderRadius: '3px',
        }}
      >
        <BorderLinearProgress variant="determinate" value={progress} />
      </Box>
      <Typography
        sx={{
          ml: 1,
          fontSize: '14px',
          fontWeight: 700,
        }}
      >
        {Math.ceil(progress)}%
      </Typography>
    </Box>
  );
}
